<template>
  <div class="flex flex-col h-full">
    <label
      class="font-medium mb-1"
      for="businessType"
      style="margin-top: 0.75rem;">סוג עסק</label>
    <div class="flex flex-wrap gap-3">
      <div class="flex align-items-center">
        <RadioButton
          v-model="businessType"
          inputId="patur"
          name="patur"
          value="patur" />
        <label for="patur" class="mr-2">עוסק פטור</label>
      </div>
      <div class="flex align-items-center">
        <RadioButton
          v-model="businessType"
          inputId="murshe"
          name="murshe"
          value="murshe" />
        <label for="ingredient2" class="mr-2">עוסק מורשה</label>
      </div>
    </div>
    <label
      class="font-medium mb-1"
      for="yaadApiKey"
      style="margin-top: 0.75rem;">מזהה API</label>
    <input-text
      id="yaadApiKey"
      v-model="credentials.key"
      placeholder="*****"
    />

    <div class="w-full mt-6 flex flex-col gap-2">
      <Button
        label="הבא"
        class="w-full"
        style="display: flex; flex-grow: 1"
        :disabled="!filledEverything"
        @click="completeIntegration"
        :loading="isLoading"
      />
      <Button
        label="הקודם"
        outlined
        class=" w-full !rounded-3xl"
        style="display: flex; flex-grow: 1"
        @click="$emit('prev')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { EzcountIntegrationParams, InvoiceProvider } from '@torim-app/types';
import { SettingsApi } from '@app/api/admin';
import { useToast } from 'vue-toastification';

const emit = defineEmits(['next', 'prev']);
const toast = useToast();

const isLoading = ref(false);
const businessType = ref<'murshe' | 'patur'>();
const credentials = ref<EzcountIntegrationParams>({
  key: '',
});

const filledEverything = computed<boolean>(() => {
  return !!businessType.value && Object.values(credentials.value).every(x => !!x);
});

const completeIntegration = async () => {
  if (filledEverything.value) {
    isLoading.value = true;
    try {
      await SettingsApi.updateSettingsAddInvoiceIntegration({
        credentials: credentials.value,
        provider: InvoiceProvider.EZCOUNT,
        businessType: businessType.value
      });
      emit('next');
    } catch (e) {
      toast.error('לא הצלחנו להוסיף את החיבור לEasyCount');
      console.log(e);
    } finally {
      isLoading.value = true;
    }
  }
};


</script>

<style scoped lang="scss">

</style>
